import React from 'react'
import { dispatch } from '@rematch/core';
import { Grid, List, Modal, Divider, Checkbox, Input, Button, Popup, Search } from 'semantic-ui-react'
import _ from 'lodash';
import ImageAvater from '../../../../drive/Components/ImageAvater';

class FilterActivity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedUsers: [],
            enabled: true
        }
    }

    componentWillMount() {
        if (this.props.advancedFilterProperties && this.props.advancedFilterProperties.selectedUsers) {
            this.setState({ selectedUsers: this.props.advancedFilterProperties.selectedUsers })
        }
    }

    componentWillReceiveProps(nextProps) {
        nextProps.associatedTeams && nextProps.associatedTeams.map((community) => {
            community && community.associatedTeam && community.associatedTeam.members && community.associatedTeam.members.map((member) => {
                this.props.advancedFilterProperties && this.props.advancedFilterProperties.members.push(member.accountUserId);
            });
        });
        if (nextProps.advancedFilterProperties && nextProps.advancedFilterProperties.selectedUsers) {
            this.setState({ selectedUsers: nextProps.advancedFilterProperties.selectedUsers })
        }
    }

    getUniqueMembers = (members) => {
        const result = [];
        const map = new Map();
        for (const item of members) {
            if (!map.has(item._id)) {
                map.set(item._id, true);
                result.push({
                    id: item._id,
                    firstName: item.firstName,
                    lastName: item.lastName,
                    profilePic: item.profilePic,
                    email: item.email
                });
            }
        }
        return result;
    }

    filterClick = () => {
        this.props.filterClick(true);
    }

    close = () => {
        this.props.closeFilterModal();
    }

    clearAll = () => {
        this.setState({ enabled: false })
        this.setState({
            value: '',
            userSearchValue: '',
            selectedUsers: []
        })

        this.props.advancedFilterProperties.roles = [];
        this.props.advancedFilterProperties.stateActiveChecked = false;
        this.props.advancedFilterProperties.stateOnHoldChecked = false;
        this.props.advancedFilterProperties.statusNotStartedChecked = false;
        this.props.advancedFilterProperties.statusCompletedChecked = false;
        this.props.advancedFilterProperties.statusIssueChecked = false;
        this.props.advancedFilterProperties.statusInProgressChecked = false;
        this.props.advancedFilterProperties.statusDelayedChecked = false;
        this.props.advancedFilterProperties.showAllRoles = false;
        this.props.advancedFilterProperties.serarchedRolesAvailable = false;
        this.props.advancedFilterProperties.searchedRoles = [];
        this.props.advancedFilterProperties.value = '';
        this.props.advancedFilterProperties.userSearchValue = '';
        this.props.advancedFilterProperties.selectedUsers = [];
        this.props.advancedFilterProperties.serarchedUsersAvailable = false;
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));

        this.props.raciFilterProperties.raciAllChecked = true;
        this.props.raciFilterProperties.accountable = false;
        this.props.raciFilterProperties.responsible = false;
        this.props.raciFilterProperties.consulted = false;
        this.props.raciFilterProperties.informed = false;
        dispatch.initiatives.setRACIFilterProperties(Object.assign({}, this.props.raciFilterProperties));
    }

    getFilteredActivities = () => {
        this.setState({ enabled: false })
        let payload = {
            initiativeId: this.props.initiativeId
        }
        if (this.props.activeTab === 'Progress') {
            payload.accountUserId = this.props.accountUserId;
            dispatch.initiatives.getAllActivities(payload);
        }

        if (this.props.activeTab === 'Sequence') {
            dispatch.initiatives.getActiveInitiativeDetailsById(payload.initiativeId);
        }

        if (this.props.activeTab === 'Teams') {
            dispatch.initiatives.getCommunityWiseActivities(payload.initiativeId);
        }

        if (this.props.activeTab === 'myactivities') {
            let payload = {
                organizationId: this.props.organizationId,
                userId: this.props.userId,
                teamId: this.props.teamId
            }
            dispatch.initiatives.getInitiativeActivitiesForMember(payload);
        }

        this.props.filterClick(false);

        // this if condition uses for fix bug number KLM-4878
        if (this.props.advancedFilterProperties.roles && this.props.advancedFilterProperties.roles.length === 0) {
            this.props.advancedFilterProperties.showAllRoles = false;
        }
    }

    handleRoleChange = (event, data, item) => {
        this.setState({ enabled: false })
        if (data.checked) {
            this.props.advancedFilterProperties.roles = [...this.props.advancedFilterProperties.roles, item._id]
        } else {
            let filteredRoles = this.props.advancedFilterProperties.roles.filter(role => role !== item._id);
            this.props.advancedFilterProperties.roles = filteredRoles;
        }
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));
    }

    handleStateChnage = (event, data) => {
        this.setState({ enabled: false })
        if (data.checked) {
            if (data.label === 'Active') {
                this.props.advancedFilterProperties.stateActiveChecked = true;
            }
            if (data.label === 'OnHold') {
                this.props.advancedFilterProperties.stateOnHoldChecked = true;
            }
        } else {
            if (data.label === 'Active') {
                this.props.advancedFilterProperties.stateActiveChecked = false;
            }
            if (data.label === 'OnHold') {
                this.props.advancedFilterProperties.stateOnHoldChecked = false;
            }
        }
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));
    }

    handleStatusChange = (event, data) => {
        this.setState({ enabled: false })
        if (data.checked) {
            if (data.label === 'Not Started') {
                this.props.advancedFilterProperties.statusNotStartedChecked = true;
            }
            if (data.label === 'Completed') {
                this.props.advancedFilterProperties.statusCompletedChecked = true;
            }
            if (data.label === 'Issue') {
                this.props.advancedFilterProperties.statusIssueChecked = true;
            }
            if (data.label === 'In Progress') {
                this.props.advancedFilterProperties.statusInProgressChecked = true;
            }
            if (data.label === 'Delayed') {
                this.props.advancedFilterProperties.statusDelayedChecked = true;
            }
        } else {
            if (data.label === 'Not Started') {
                this.props.advancedFilterProperties.statusNotStartedChecked = false;
            }
            if (data.label === 'Completed') {
                this.props.advancedFilterProperties.statusCompletedChecked = false;
            }
            if (data.label === 'Issue') {
                this.props.advancedFilterProperties.statusIssueChecked = false;
            }
            if (data.label === 'In Progress') {
                this.props.advancedFilterProperties.statusInProgressChecked = false;
            }
            if (data.label === 'Delayed') {
                this.props.advancedFilterProperties.statusDelayedChecked = false;
            }
        }
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));
    }

    handleRaciChange = (event, data) => {
        this.setState({ enabled: false })
        if (data.checked) {
            if (data.label === 'All') {
                this.props.raciFilterProperties.raciAllChecked = true;
                this.props.raciFilterProperties.accountable = false;
                this.props.raciFilterProperties.responsible = false;
                this.props.raciFilterProperties.consulted = false;
                this.props.raciFilterProperties.informed = false;
            }
            if (data.label === 'Accountable') {
                this.props.raciFilterProperties.raciAllChecked = false;
                this.props.raciFilterProperties.accountable = true;
            }
            if (data.label === 'Responsible') {
                this.props.raciFilterProperties.raciAllChecked = false;
                this.props.raciFilterProperties.responsible = true;
            }
            if (data.label === 'Consulted') {
                this.props.raciFilterProperties.raciAllChecked = false;
                this.props.raciFilterProperties.consulted = true;
            }
            if (data.label === 'Informed') {
                this.props.raciFilterProperties.raciAllChecked = false;
                this.props.raciFilterProperties.informed = true;
            }
        } else {
            if (data.label === 'All') {
                this.props.raciFilterProperties.raciAllChecked = false;
            }
            if (data.label === 'Accountable') {
                this.props.raciFilterProperties.accountable = false;
            }
            if (data.label === 'Responsible') {
                this.props.raciFilterProperties.responsible = false;
            }
            if (data.label === 'Consulted') {
                this.props.raciFilterProperties.consulted = false;
            }
            if (data.label === 'Informed') {
                this.props.raciFilterProperties.informed = false;
            }
        }
        if (!this.props.raciFilterProperties.accountable &&
            !this.props.raciFilterProperties.responsible &&
            !this.props.raciFilterProperties.consulted &&
            !this.props.raciFilterProperties.informed) {
            this.props.raciFilterProperties.raciAllChecked = true;
        }

        dispatch.initiatives.setRACIFilterProperties(Object.assign({}, this.props.raciFilterProperties));
    }

    showMoreRoles = () => {
        this.props.advancedFilterProperties.showAllRoles = true;
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));
    }

    resetComponent = () => {
        this.props.advancedFilterProperties.searchedRoles = [];
        this.props.advancedFilterProperties.value = '';
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));
    }

    handleSearchChange = (e, { value }) => {
        this.setState({ enabled: false })
        this.setState({ value });
        if (value) {
            this.props.advancedFilterProperties.serarchedRolesAvailable = true;
        } else {
            this.props.advancedFilterProperties.serarchedRolesAvailable = false;
        }

        const re = new RegExp(_.escapeRegExp(value), 'i')
        const isMatch = result => re.test(result.name)
        this.props.advancedFilterProperties.searchedRoles = _.filter(this.props.associatedTeams, isMatch)
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));
    }

    handleUserSearchChange = (e, { value }) => {
        this.setState({ enabled: false })
        this.setState({ userSearchValue: value });
        if (value) {
            this.props.advancedFilterProperties.serarchedUsersAvailable = true;
        } else {
            this.props.advancedFilterProperties.serarchedUsersAvailable = false;
        }

        const re = new RegExp(_.escapeRegExp(value), 'i')
        const isMatch = result => re.test(result.firstName + ' ' + result.lastName)
        this.props.advancedFilterProperties.searchedUsers = _.filter(this.getUniqueMembers(this.props.advancedFilterProperties.members), isMatch);
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));
    }

    handleUserSelection = (event, data, selectedUser) => {
        this.setState({ enabled: false })
        if (this.state.selectedUsers.includes(selectedUser.id)) {
            let filteredUsers = this.state.selectedUsers.filter(user => user !== selectedUser.id);
            this.setState({ selectedUsers: filteredUsers });
            this.props.advancedFilterProperties.selectedUsers = filteredUsers;
        } else {
            this.setState({ selectedUsers: [...this.state.selectedUsers, selectedUser.id] })
            this.props.advancedFilterProperties.selectedUsers = [...this.state.selectedUsers, selectedUser.id]
        }
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));
    }

    hoverComponent = (trigger, user) => {
        return (<Popup
            key={user.id}
            header={user.firstName + " " + user.lastName}
            className="popupStyled" inverted
            trigger={trigger}
            style={{ zIndex: 99999999 }}
        />)
    }

    render() {
        let uniqueMembers = [];
        if (this.props.advancedFilterProperties && this.props.advancedFilterProperties.serarchedUsersAvailable) {
            uniqueMembers = this.props.advancedFilterProperties.searchedUsers;
        } else {
            if (this.props.advancedFilterProperties && this.props.advancedFilterProperties.members) {
                uniqueMembers = this.getUniqueMembers(this.props.advancedFilterProperties.members);
            }

        }

        let allRoles = [];
        if (this.props.advancedFilterProperties && this.props.advancedFilterProperties.serarchedRolesAvailable) {
            allRoles = this.props.advancedFilterProperties.searchedRoles;
        } else {
            if (this.props.advancedFilterProperties && this.props.advancedFilterProperties.showAllRoles) {
                for (let index = 0; index < this.props.associatedTeams.length; index++) {
                    allRoles.push(this.props.associatedTeams[index]);
                }
            } else {
                for (let index = 0; index < 5; index++) {
                    allRoles.push(this.props.associatedTeams[index]);
                }
            }
        }

        return (
            <Modal
                className="filterModal basicModal"
                open={this.props.open}
                onClose={this.close}
                size='small'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>Filters</Modal.Header>
                <Modal.Content className="pad_0">
                    {
                        this.props.activeTab !== 'Progress' && this.props.activeTab !== 'myactivities' ?
                            <div>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={4}>
                                            Activities
                                </Grid.Column>
                                        <Grid.Column width={12}>
                                            <Grid>
                                                <Grid.Row>
                                                    <Grid.Column width={5}>
                                                        <Checkbox label='All' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties && this.props.raciFilterProperties.raciAllChecked} />
                                                    </Grid.Column>
                                                    <Grid.Column width={5}>
                                                        <Checkbox label='Accountable' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties && this.props.raciFilterProperties.accountable} />
                                                    </Grid.Column>
                                                    <Grid.Column width={5}>
                                                        <Checkbox label='Responsible' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties && this.props.raciFilterProperties.responsible} />
                                                    </Grid.Column>
                                                    <Grid.Column width={5}>
                                                        <Checkbox label='Consulted' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties && this.props.raciFilterProperties.consulted} />
                                                    </Grid.Column>
                                                    <Grid.Column width={5}>
                                                        <Checkbox label='Informed' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties && this.props.raciFilterProperties.informed} />
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                <Divider />
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={4}>
                                            Status
                                    </Grid.Column>
                                        <Grid.Column width={12}>
                                            <Grid>
                                                <Grid.Row>
                                                    <Grid.Column width={5}>
                                                        <Checkbox label='Not Started' onChange={(event, data) => this.handleStatusChange(event, data)} checked={this.props.advancedFilterProperties && this.props.advancedFilterProperties.statusNotStartedChecked} />
                                                    </Grid.Column>
                                                    <Grid.Column width={5}>
                                                        <Checkbox label='Completed' onChange={(event, data) => this.handleStatusChange(event, data)} checked={this.props.advancedFilterProperties && this.props.advancedFilterProperties.statusCompletedChecked} />
                                                    </Grid.Column>
                                                    <Grid.Column width={5}>
                                                        <Checkbox label='Issue' onChange={(event, data) => this.handleStatusChange(event, data)} checked={this.props.advancedFilterProperties && this.props.advancedFilterProperties.statusIssueChecked} />
                                                    </Grid.Column>
                                                    <Grid.Column width={5}>
                                                        <Checkbox label='In Progress' onChange={(event, data) => this.handleStatusChange(event, data)} checked={this.props.advancedFilterProperties && this.props.advancedFilterProperties.statusInProgressChecked} />
                                                    </Grid.Column>
                                                    <Grid.Column width={5}>
                                                        <Checkbox label='Delayed' onChange={(event, data) => this.handleStatusChange(event, data)} checked={this.props.advancedFilterProperties && this.props.advancedFilterProperties.statusDelayedChecked} />
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </div>
                            : ''
                    }
                    <Divider />
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={4}>
                                State
                            </Grid.Column>
                            <Grid.Column width={12}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={5}>
                                            <Checkbox label='Active' onChange={(event, data) => this.handleStateChnage(event, data)} checked={this.props.advancedFilterProperties && this.props.advancedFilterProperties.stateActiveChecked} />
                                        </Grid.Column>
                                        <Grid.Column width={5}>
                                            <Checkbox label='OnHold' onChange={(event, data) => this.handleStateChnage(event, data)} checked={this.props.advancedFilterProperties && this.props.advancedFilterProperties.stateOnHoldChecked} />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    {
                        this.props.activeTab !== 'myactivities' ?
                            <Divider /> : ''
                    }
                    <Grid>
                        {
                            this.props.activeTab === 'myactivities' ?
                                '' :
                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        Roles
                                    </Grid.Column>
                                    <Grid.Column width={12}>
                                        <Grid>
                                            <Grid.Row>
                                                <Grid.Column width={16}>
                                                    <Input
                                                        fluid
                                                        icon="search"
                                                        placeholder='Search...'
                                                        onChange={this.handleSearchChange}
                                                        value={this.state.value}
                                                        {...this.props.associatedTeams}
                                                    />
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                                {
                                                    allRoles && allRoles.length > 0 ? allRoles.map((item, index) => {
                                                        if (item) {
                                                            return (
                                                                <Grid.Column width={5} key={index}>
                                                                    <Checkbox
                                                                        label={item.name}
                                                                        onChange={(event, data) => this.handleRoleChange(event, data, item)}
                                                                        checked={this.props.advancedFilterProperties && this.props.advancedFilterProperties.roles.includes(item._id)} />
                                                                </Grid.Column>
                                                            )
                                                        }
                                                    })
                                                        :
                                                        <label className="f_12" >
                                                            No results found.
                                                    </label>
                                                }
                                                {
                                                    this.props.associatedTeams && this.props.associatedTeams.length > 5 && this.props.advancedFilterProperties && !this.props.advancedFilterProperties.showAllRoles && !this.props.advancedFilterProperties.serarchedRolesAvailable ?
                                                        <Grid.Column width={5}>
                                                            <label className="clr-blue cursor-pointer f_12" onClick={this.showMoreRoles}>
                                                                {this.props.associatedTeams && this.props.associatedTeams.length - 5} More...
                                                            </label>
                                                        </Grid.Column> : ''
                                                }

                                            </Grid.Row>
                                        </Grid>
                                    </Grid.Column>
                                </Grid.Row>
                        }

                    </Grid>
                    <Divider />
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={4}>
                                Members
                                </Grid.Column>
                            <Grid.Column width={6}>
                                <Input
                                    fluid
                                    icon="search"
                                    placeholder='Search...'
                                    onChange={this.handleUserSearchChange}
                                    value={this.state.userSearchValue}
                                    {...uniqueMembers}
                                />
                            </Grid.Column>
                            <Grid.Column width={6}>
                                <List horizontal >
                                    {
                                        uniqueMembers.length > 0 ? uniqueMembers.map((member, index) => {
                                            if (index < 4) {
                                                return (
                                                    <List.Item key={index}>
                                                        <ImageAvater
                                                            avatar
                                                            user={member}
                                                            onClick={(event, data) => this.handleUserSelection(event, data, member)}
                                                            className={this.state.selectedUsers.includes(member.id) ? "cursor-pointer highLightImage" : 'cursor-pointer'}
                                                            imageStyle={this.state.selectedUsers.includes(member.id) ? "cursor-pointer highLightImage" : 'cursor-pointer'}
                                                            hoverComponent={this.hoverComponent}
                                                        />
                                                    </List.Item>
                                                )
                                            }
                                        }) :
                                            <label className="f_12" >
                                                No results found.
                                        </label>
                                    }
                                    {
                                        uniqueMembers.length > 4 ?
                                            <List.Item style={{
                                                verticalAlign: "middle", 'margin-top': '-28px',
                                                'margin-left': '5px'
                                            }}  >
                                                <span avatar className="searchUsersCount">
                                                    +{uniqueMembers.length - 4}
                                                </span>
                                            </List.Item>
                                            : ''
                                    }
                                </List>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions className="actionInFormcy">
                    <Button content='Clear All' className="pull-left button-cancel" onClick={this.clearAll} />
                    <Button content='Cancel' className="button-cancel" onClick={this.close} />
                    <Button content='Apply' disabled={this.state.enabled} className="button-submit" onClick={this.getFilteredActivities} />
                </Modal.Actions>
            </Modal>

        )
    }
}

export default FilterActivity;